import React from "react";
import styled from "styled-components";
import { layout, LayoutProps, space, SpaceProps, typography, TypographyProps } from "styled-system";

const TrWrapper = styled.tr`
  ${typography};
  ${space};
  ${layout};
  height: 100%;
  border-bottom: 1px solid #bdbdbd;
`;

export const Tr: React.FC<TypographyProps & SpaceProps & LayoutProps> = ({ children, ...props }) => (
  <TrWrapper {...props}>{children}</TrWrapper>
);
